import { useEffect, useState } from "react";
import "../Styles/component.css";
import "../Styles/global.css";

const InputTitle = ({
  setTitle,
  title,
  placeholder = "제목을 입력해주세요(필수*)",
  readOnly = false,
}) => {
  const [title_count, setTitle_count] = useState(0);

  const handleTitleChange = (e) => {
    if (readOnly) {
      return;
    }

    const value = e.target.value;
    if (value.length <= 30) {
      setTitle(value);
      setTitle_count(value.length);
    }
  };

  useEffect(() => {
    setTitle_count(title.length);
  }, [title]);
  return (
    <div className="textinputBox" style={{ marginTop: "14px" }}>
      <input
        type="text"
        placeholder={placeholder}
        style={{ width: "648px", height: "23px" }}
        className="textinput"
        value={title}
        onChange={handleTitleChange}
        readOnly={readOnly}
      />
      <div style={{ color: "#888888", marginLeft: "auto" }}>
        {title_count}/30
      </div>
    </div>
  );
};

export default InputTitle;
